<template>
	<main class="common-main-container">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="loading"
		>
			<Spinner />
		</div>
		<header>
			<h1>Admin Console</h1>
		</header>
		<body class="my-2 admin-console-container">
			<b-container>
				<header class="d-flex align-items-center justify-content-between">
					<div class="add-res-tabs w-100 position-relative ml-2">
						<b-tabs v-model="tabIndex" content-class="mt-1" justified>
							<b-tab
								title="Individuals"
								active
								@click="changeRoute('individual'), resetFilter('individual')"
							>
								<div class="selected-border"></div>
							</b-tab>
							<b-tab
								title="Group"
								@click="changeRoute('group'), resetFilter('group')"
							>
								<div class="selected-border left-133"></div>
							</b-tab>
						</b-tabs>
					</div>
					<div class="position-relative">
						<b-button class="new-addBtn" @click="openFilter = !openFilter">
							<img
								class="mr-2"
								src="../../assets/common-icons/whitefilter.svg"
								alt=""
							/>
							<div
								class="mb-3"
								style="position: absolute; top: 1px; left: 31px"
								v-if="filtersApplied"
							>
								<img src="../../assets/common-icons/fil_selected.svg" alt="" />
							</div>
							Filter
						</b-button>
						<div class="config-filter-dropdown" v-if="openFilter">
							<section>
								<SingleSelect
									:optionsArray="projects"
									v-model="filters.project"
									text="Project:"
								/>
							</section>
							<section class="mt-3">
								<SingleSelect
									:optionsArray="sandboxTemplates"
									v-model="filters.sandboxTemplate"
									text="Template:"
									:hideEdit="true"
									nested
									showLeft
								/>
							</section>
							<section class="mt-3">
								<DateField v-model="filters.date" text="Assigned on:" />
							</section>
							<section class="mt-3" v-if="tabIndex == 0">
								<SingleSelect
									:optionsArray="projectStatus"
									v-model="filters.status"
									text="Status:"
								/>
							</section>
							<div
								class="d-flex align-items-center justify-content-between filter-buttons mt-4"
							>
								<b-button @click="hideFiltersDropdown()">Cancel</b-button>
								<span>
									<b-button
										:disabled="disableFilters"
										class="mr-3"
										@click="
											resetFilter(tabIndex == 0 ? 'individual' : 'group', false)
										"
										>Reset</b-button
									>
									<b-button :disabled="disableFilters" @click="applyFilters()"
										>Apply</b-button
									>
								</span>
							</div>
						</div>
					</div>
				</header>

				<div class="adminConsole-main-table">
					<section
						v-if="
							consoleData.data &&
								!consoleData.data.length &&
								searchTopicTest != ''
						"
						class="h-100 d-flex align-items-center justify-content-center w-100"
					>
						<div class="text-center">
							<img
								src="../../assets/projects-icons/no-search-projects.svg"
								alt=""
							/>
							<div class="no-data-txt">
								No matching result for "{{ searchTopicTest }}"
							</div>
						</div>
					</section>
					<section
						v-else-if="!loading && consoleData.data && !consoleData.data.length"
						class="h-100 d-flex align-items-center justify-content-center w-100"
					>
						<div class="text-center">
							<img
								src="../../assets/projects-icons/empty-admin-console.svg"
								alt=""
							/>
							<div class="no-data-txt">
								<span v-if="filtersApplied">
									There are no projects available for the applied filter.
								</span>
								<span v-else-if="tabIndex == 0"
									>No link has been shared to the candidate</span
								>
								<span v-else-if="tabIndex == 1"
									>No link has been shared to the group</span
								>
								<span v-else>No link has been shared</span>
							</div>
						</div>
					</section>
					<div
						v-if="consoleData.data && consoleData.data.length"
						class="adminConsole-table-header"
					>
						<div class="transparent-bar"></div>
						<div style="visibility: hidden">
							<b-avatar size="sm"></b-avatar>
						</div>
						<div style="width: 20%">
							<span class="ml-4">
								{{ tabIndex == 0 ? "Candidate Email" : "Group Name" }}
							</span>
							<img
								@click="sortColumn(tabIndex == 0 ? 'emailID' : 'groupName')"
								:src="
									getSortedImages(
										tabIndex == 0 ? 'emailID' : 'groupName',
										sorting.column,
										sorting.order
									)
								"
								alt=""
								class="pointer ml-2"
							/>
						</div>
						<div style="width: 20%">
							Project Title
							<img
								@click="sortColumn('projectName')"
								:src="
									getSortedImages('projectName', sorting.column, sorting.order)
								"
								alt=""
								class="pointer ml-2"
							/>
						</div>
						<div style="width: 15%" class="p-0">
							Template Name
							<img
								@click="sortColumn('templateName')"
								:src="
									getSortedImages('templateName', sorting.column, sorting.order)
								"
								alt=""
								class="pointer ml-2"
							/>
						</div>
						<div style="width: 10%">
							Assigned On
							<img
								@click="sortColumn('createdAt')"
								:src="
									getSortedImages('createdAt', sorting.column, sorting.order)
								"
								alt=""
								class="pointer ml-2"
							/>
						</div>
						<div style="width: 15%">Status</div>
						<div style="width: 10%">Marks</div>
						<div style="width: 10%" class="text-center">Action</div>
					</div>
					<div
						v-if="!loading && consoleData.data && consoleData.data.length"
						class="adminConsole-table-body"
					>
						<div
							v-for="(data, index) in consoleData.data"
							:key="data.uuid"
							class="adminConsole-data-row w-100 d-flex align-items-center flex-column justify-content-center"
							:class="data.uuid == 1 ? 'adminConsole-sel-row' : ''"
						>
							<div class="d-flex align-items-center height-40 w-100">
								<div class="blue-bar"></div>
								<div>
									<b-avatar
										size="sm"
										:icon="tabIndex == 1 ? 'people-fill' : ''"
									></b-avatar>
								</div>
								<div
									style="width: 20%"
									class="d-flex align-items-center config-radio-parent pl-1"
								>
									<span class="text-truncate ml-4 mr-2">
										{{ tabIndex == 0 ? data.emailID : data.groupName }}
									</span>
								</div>
								<div style="width: 20%" class="pl-1">
									{{ data.projectName }}
								</div>
								<div
									style="width: 15%"
									class="d-flex align-items-center pl-2 config-radio-parent"
								>
									<span class="text-truncate">
										{{ data.templateName }}
									</span>
								</div>
								<div style="width: 10%">
									{{ getDate(data.createdAt) }}
								</div>
								<div v-if="tabIndex == 0" style="width: 15%">
									<div v-if="data.status == 0">Yet to start</div>
									<div v-else-if="data.status == 1" class="running-txt">
										Running
									</div>
									<div v-else-if="data.status == 2" class="paused-txt">
										Paused
									</div>
									<div v-else-if="data.status == 3">
										<div class="green-txt">Submitted</div>
										<div class="time-class">
											{{ getFormattedDate(data.submittedAt) }}
										</div>
									</div>
									<div v-else-if="data.status == 4" class="evaluated-txt">
										Evaluated
									</div>
									<div v-else-if="data.status == 5" class="red-txt">
										Force Stopped
									</div>
									<div v-else class="red-txt">Reset</div>
								</div>
								<div
									v-else
									style="width: 15%"
									class="d-flex align-items-center mt-1"
								>
									<div class="red-line mr-1" style="width: 34px"></div>
									<div class="orange-line mr-1"></div>
									<div class="golden-line mr-1"></div>
									<div class="blue-line mr-1"></div>
									<div class="green-line" style="width: 48px"></div>
								</div>
								<div style="width: 10%">
									<span
										v-if="data.formattedAvgMarks || data.formattedAvgMarks == 0"
									>
										{{ data.formattedAvgMarks }} (avg)
									</span>
									<span
										v-else-if="data.formattedMarks || data.formattedMarks == 0"
									>
										{{ data.formattedMarks }}
									</span>
									<img
										v-else
										class="ml-4"
										src="../../assets/projects-icons/Line.svg"
										alt=""
									/>
								</div>
								<div
									v-if="tabIndex == 0 && data.actions.viewMarks"
									style="width: 10%"
									class="d-flex align-items-center justify-content-center filter-buttons"
								>
									<b-button class="new-addBtn" @click="evaluateCandidate(data)">
										View Marks
									</b-button>
								</div>
								<div
									v-else-if="tabIndex == 0 && data.actions.evaluate"
									style="width: 10%"
									class="d-flex align-items-center justify-content-center filter-buttons"
								>
									<b-button @click="evaluateCandidate(data)" class="new-addBtn">
										Evaluate
									</b-button>
								</div>
								<div
									v-else
									style="width: 10%"
									class="d-flex align-items-center justify-content-center"
								>
									<img
										v-if="tabIndex == 0"
										@click="data.actions.viewIDE && adminActions('view', data)"
										class="mr-4"
										:class="data.actions.viewIDE && 'pointer'"
										:src="
											data.actions.viewIDE
												? require('../../assets/common-icons/view.svg')
												: require('../../assets/projects-icons/disabled-eye-icon.svg')
										"
										alt=""
									/>
									<img
										v-if="tabIndex == 0"
										@click="
											data.actions.restart && adminActions('reload', data)
										"
										class="mr-4"
										:class="data.actions.restart && 'pointer'"
										:src="
											data.actions.restart
												? require('../../assets/projects-icons/reload-icon.svg')
												: require('../../assets/projects-icons/disabled-load-icon.svg')
										"
										alt=""
									/>
									<img
										v-if="tabIndex == 0"
										@click="
											data.actions.terminate && adminActions('delete', data)
										"
										class="mr-2"
										:class="data.actions.terminate && 'pointer'"
										:src="
											data.actions.terminate
												? require('../../assets/projects-icons/restrict-icon.svg')
												: require('../../assets/projects-icons/disabled-restrict-icon.svg')
										"
										alt=""
									/>
									<template v-if="tabIndex == 1">
										<template v-if="data.actionsEnabled">
											<img
												v-if="data.actionsEnabled"
												class="pointer mr-4"
												src="../../assets/projects-icons/reload-icon.svg"
												alt=""
												@click="adminGroupAction('reload', data)"
											/>
											<img
												v-if="data.actionsEnabled"
												class="pointer mr-4"
												src="../../assets/projects-icons/restrict-icon.svg"
												alt=""
												@click="adminGroupAction('delete', data)"
											/>
										</template>
										<template v-else>
											<img
												class="mr-4"
												src="../../assets/projects-icons/disabled-load-icon.svg"
												alt=""
											/>
											<img
												class="mr-4"
												src="../../assets/projects-icons/disabled-restrict-icon.svg"
												alt=""
											/>
										</template>
										<img
											class="pointer"
											src="../../assets/projects-icons/down-arrow.svg"
											alt=""
											@click="
												selectGroupIndex === index
													? (selectGroupIndex = null)
													: selectGroupView(index)
											"
										/>
									</template>
								</div>
							</div>
							<div
								v-if="tabIndex == 1 && selectGroupIndex === index"
								class="w-100"
							>
								<hr class="w-100 my-2" />
								<div class="group-font">Group Participants:</div>
								<div class="overflow-auto height-250">
									<div
										class="w-100 d-flex align-items-center flex-column justify-content-center"
									>
										<div
											v-for="childData in data.candidates"
											:key="childData.userID"
											class="w-100 d-flex align-items-center height-40"
											style="margin-block: 10px"
										>
											<div>
												<b-avatar size="sm"></b-avatar>
											</div>
											<div
												style="width: 20%"
												class="d-flex align-items-center config-radio-parent"
											>
												<span class="text-truncate ml-4 mr-2">
													{{ childData.emailID }}
												</span>
											</div>
											<div style="width: 20%" class="pl-1">
												{{ data.projectName }}
											</div>
											<div
												style="width: 15%"
												class="d-flex align-items-center pl-2 config-radio-parent"
											>
												<span class="text-truncate">
													{{ data.templateName }}
												</span>
											</div>
											<div style="width: 10%">
												{{ getDate(data.createdAt) }}
											</div>
											<div style="width: 15%">
												<div v-if="childData.status == 0">Yet to start</div>
												<div
													v-else-if="childData.status == 1"
													class="running-txt"
												>
													Running
												</div>
												<div
													v-else-if="childData.status == 2"
													class="paused-txt"
												>
													Paused
												</div>
												<div v-else-if="childData.status == 3">
													<div class="green-txt">Submitted</div>
													<div class="time-class">
														{{ getFormattedDate(childData.submittedAt) }}
													</div>
												</div>
												<div
													v-else-if="childData.status == 4"
													class="evaluated-txt"
												>
													Evaluated
												</div>
												<div v-else-if="childData.status == 5" class="red-txt">
													Force Stopped
												</div>
												<div v-else class="red-txt">Reset</div>
											</div>
											<div style="width: 10%">
												<span
													v-if="childData.marks || childData.marks == 0"
													class="ml-3"
												>
													{{ childData.formattedMarks }}
												</span>
												<img
													v-else
													class="ml-4"
													src="../../assets/projects-icons/Line.svg"
													alt=""
												/>
											</div>
											<div
												v-if="childData.actions.viewMarks"
												style="width: 10%"
												class="d-flex align-items-center justify-content-center filter-buttons"
											>
												<b-button @click="evaluateCandidate(data, childData)">
													View Marks
												</b-button>
											</div>
											<div
												v-else-if="childData.actions.evaluate"
												style="width: 10%"
												class="d-flex align-items-center justify-content-center filter-buttons"
											>
												<b-button @click="evaluateCandidate(data, childData)">
													Evaluate
												</b-button>
											</div>
											<div
												v-else
												style="width: 10%"
												class="d-flex align-items-center justify-content-center"
											>
												<img
													v-if="tabIndex == 1"
													@click="
														childData.actions.viewIDE &&
															adminActions('view', data, childData)
													"
													class="mr-4"
													:class="childData.actions.viewIDE && 'pointer'"
													:src="
														childData.actions.viewIDE
															? require('../../assets/common-icons/view.svg')
															: require('../../assets/projects-icons/disabled-eye-icon.svg')
													"
													alt=""
												/>
												<img
													v-if="tabIndex == 1"
													@click="
														childData.actions.restart &&
															adminActions('reload', data, childData)
													"
													class="mr-4"
													:class="childData.actions.restart && 'pointer'"
													:src="
														childData.actions.restart
															? require('../../assets/projects-icons/reload-icon.svg')
															: require('../../assets/projects-icons/disabled-load-icon.svg')
													"
													alt=""
												/>
												<img
													v-if="tabIndex == 1"
													@click="
														childData.actions.terminate &&
															adminActions('delete', data, childData)
													"
													:class="childData.actions.terminate && 'pointer'"
													:src="
														childData.actions.terminate
															? require('../../assets/projects-icons/restrict-icon.svg')
															: require('../../assets/projects-icons/disabled-restrict-icon.svg')
													"
													alt=""
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-else class="adminConsole-table-body"></div>
					<div
						v-if="consoleData.data && consoleData.data.length"
						class="adminConsole-paginaTion d-flex justify-content-between align-items-center"
					>
						<div style="width: 45%" class="d-flex">
							<span class="qb-gotopage-text p-1">Go to page</span>
							<b-form-input
								v-model="pagination.page"
								style="width: 9%"
								type="text"
								class="qb-pagination-num mr-1"
								min="1"
							></b-form-input>
							<b-button class="qb-pagination-addbtn">
								<span
									><img src="../../assets/whiterightarrow.svg" alt=""
								/></span>
							</b-button>
						</div>

						<div style="width: 30%" class="pagination">
							<b-pagination
								align="center"
								@input="getConsoleData(tabIndex == 0 ? 'individual' : 'group')"
								v-model.number="pagination.page"
								:total-rows="consoleData.total"
								:per-page="pagination.count"
								first-number
								last-number
							>
								<template #prev-text
									><span><img src="../../assets/leftvector.svg" alt="" /> </span
								></template>
								<template #next-text
									><span><img src="../../assets/rightarrow.svg" alt=""/></span
								></template>
							</b-pagination>
						</div>
						<div
							style="width: 25%"
							class="qb-gotopage-text mr-2 d-flex justify-content-end"
						>
							Results :
							<!-- <span class="ml-1 mr-1" v-if="pageStart > total">0</span> -->
							<span class="ml-1 mr-1">
								{{ consoleData.pageStart }}
							</span>
							- {{ consoleData.pageEnd }}
							<span class="pl-1"></span>
							of
							<span class="pr-1"></span>
							{{ consoleData.total }}
						</div>
					</div>
				</div>
			</b-container>
		</body>

		<WarningModal />
		<cloneTemplateModal />
		<ConfirmationModal
			v-if="isConfirmModal"
			:header="'Warning'"
			:button="'Continue'"
			:showModal="isConfirmModal"
			:loader="LoaderStatus"
			:confirmMessage="confirmMessage"
			:svgPath="'projects-icons/activateWarn.svg'"
			@save="saveAction()"
			@close="closeAction()"
		/>
	</main>
</template>

<script>
import ConfirmationModal from "../../components/modals/ConfirmationModal";
import SingleSelect from "../../components/InputComponents/SingleSelect.vue";
import WarningModal from "../../views/sandboxes/modals/WarningModal.vue";
import cloneTemplateModal from "../../views/sandboxes/modals/CloneTemplate.vue";
import {
	adminConsole,
	deleteCadidateIde,
	getAllProjects,
	getSandBoxTemplate,
} from "../../utils/apiFunctions";
import { DateTime } from "luxon";
import DateField from "../../components/InputComponents/DateField.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { mapGetters } from "vuex";
import errorToast from "../../views/mixin/toast";
import successToast from "../../views/mixin/toast";
export default {
	name: "admin-console",
	mixins: [errorToast, successToast],
	data() {
		return {
			LoaderStatus: false,
			sandboxUrl: null,
			filtersApplied: false,
			appliedFilters: {},
			consoleData: {},
			tabIndex: 0,
			selectGroupIndex: null,
			openFilter: false,
			loading: false,
			projectStatus: [
				{ value: 0, text: "Not yet started" },
				{ value: 1, text: "Running" },
				{ value: 2, text: "Paused" },
				{ value: 3, text: "Submitted" },
				{ value: 4, text: "Evaluated" },
				{ value: 5, text: "Force Stopped" },
				{ value: 6, text: "Reset" },
			],
			sandboxTemplates: [],
			projects: [],
			filters: {
				sandboxTemplate: null,
				date: null,
				project: null,
				status: null,
			},
			pagination: {
				page: 1,
				count: 20,
			},
			sorting: {
				column: undefined,
				order: undefined,
			},
			search: null,
			actionParams: {},
			actionTestID: null,
			isConfirmModal: false,
			confirmMessage: null,
		};
	},
	components: {
		SingleSelect,
		WarningModal,
		cloneTemplateModal,
		DateField,
		Spinner,
		ConfirmationModal,
	},
	computed: {
		...mapGetters("searchVUEX", {
			searchTopicTest: "getSearchTopicTest",
		}),
		disableFilters() {
			if (
				this.filters.sandboxTemplate ||
				this.filters.date ||
				this.filters.project ||
				this.filters.status
			) {
				return false;
			} else {
				return true;
			}
		},
	},
	async mounted() {
		this.$router.push({
			name: "adminconsole",
			query: {
				type: "individual",
			},
		});
		this.getConsoleData("individual");
		try {
			const [projectResponse, response] = await Promise.all([
				getAllProjects({ minimal: true }),
				getSandBoxTemplate(),
			]);
			this.projects = projectResponse.data.data.data.map((value) => ({
				text: value.name,
				value: value.testID,
				...value,
			}));
			this.sandboxTemplates = response.data.data.data.map((value) => ({
				text: value.title,
				value: value.questionKey,
				...value,
			}));
		} catch (error) {
			console.log(error);
		}
	},
	watch: {
		$route() {
			if (this.$route.query.type === "individual") {
				this.tabIndex = 0;
			} else {
				this.tabIndex = 1;
			}
		},
		searchTopicTest() {
			this.search = this.searchTopicTest;
			this.pagination.page = 1;
			this.getConsoleData(this.tabIndex == 0 ? "individual" : "group");
		},
	},
	methods: {
		async adminGroupAction(action, data) {
			const params = {
				testUUID: data.uuid,
				attemptNo: data.attemptNo,
				topicID: this.consoleData.topicID,
				groupID: data.groupID,
				emailID: data.emailID,
				type: "group",
			};
			if (action == "delete") params.unshare = true;
			this.actionParams = params;
			this.actionTestID = data.testID;
			this.isConfirmModal = true;
			if (action == "reload") {
				this.confirmMessage = `Are you sure you want to <span style="font-weight: 600;">reset the project</span> for the group <span class="supporting-txt">"${data.groupName}"</span>?`;
			} else {
				this.confirmMessage = `Are you sure you want to <span style="font-weight: 600;">terminate the project</span> for the group <span class="supporting-txt">"${data.groupName}"</span>?`;
			}
		},
		changeRoute(type) {
			this.$router.push({
				name: "adminconsole",
				query: {
					type,
				},
			});
		},
		getFormattedDate(date) {
			return DateTime.fromISO(date)
				.setZone("Asia/Kolkata")
				.toFormat("hh:mm a, dd.MM.yyyy");
		},
		evaluateCandidate(data, childData) {
			console.log(data, childData);
			this.$router.push({
				path: `/proctoring/evaluatetest/${data.testID}/${
					this.consoleData.topicID
				}/${data.groupID}/${data.userID || childData.userID}/${
					this.tabIndex == 0 ? "I" : "G"
				}?attemptNo=${data.attemptNo ||
					childData.attemptNo}&fromRoute=sandbox&type=${
					this.tabIndex == 0 ? "individual" : "group"
				}&emailID=${data.emailID || childData.emailID}`,
			});
		},

		closeAction() {
			this.actionParams = {};
			this.actionTestID = null;
			this.isConfirmModal = false;
		},
		async saveAction() {
			if(this.LoaderStatus) return;
			this.LoaderStatus = true;
			try {
				await deleteCadidateIde(this.actionTestID, this.actionParams);
				if (this.actionParams.unshare) {
					this.successToast("Project successfully terminated");
				} else {
					this.successToast("Project successfully restarted");
				}
				this.getConsoleData(this.tabIndex == 0 ? "individual" : "group");
				this.closeAction();
			} catch (error) {
				console.log(error);
			} finally {
				this.LoaderStatus = false;
			}
		},
		async adminActions(actionType, data, childData) {
			try {
				const params = {
					testUUID: data.uuid || childData.uuid,
					attemptNo: data.attemptNo || childData.attemptNo,
					topicID: this.consoleData.topicID,
					groupID: data.groupID,
					emailID: data.emailID || childData.emailID,
					userID: data.userID || childData.userID,
				};
				if (actionType == "delete" || actionType == "reload") {
					if (actionType == "delete") params.unshare = true;
					this.actionParams = params;
					this.actionTestID = data.testID;
					this.isConfirmModal = true;
					if (actionType == "reload") {
						this.confirmMessage = `Are you sure you want to <span style="font-weight: 600;">reset the project</span> for the candidate <span class="supporting-txt">"${params.emailID}"</span>?`;
					} else {
						this.confirmMessage = `Are you sure you want to <span style="font-weight: 600;">terminate the project</span> for the candidate <span class="supporting-txt">"${params.emailID}"</span>?`;
					}
				} else {
					this.LoaderStatus = true;
					this.$router.push({
						name: "view-code-sandbox",
						params: {
							testID: data.testID,
							...params,
						},
					});
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.LoaderStatus = false;
			}
		},
		sortColumn(column) {
			if (this.sorting.column != column) {
				this.sorting.order = undefined;
				this.sorting.column = undefined;
			}
			this.sorting.column = column;
			if (this.sorting.order == undefined) {
				this.sorting.order = 1;
			} else if (this.sorting.order == 1) {
				this.sorting.order = -1;
			} else {
				this.sorting.order = undefined;
				this.sorting.column = undefined;
			}
			this.getConsoleData(this.tabIndex == 0 ? "individual" : "group");
		},
		getSortedImages(sortColumn, column, order) {
			return sortColumn == column && order == 1
				? require("@/assets/common-icons/ascending.svg")
				: sortColumn == column && order == -1
				? require("@/assets/common-icons/descending.svg")
				: require("@/assets/common-icons/nosort.svg");
		},
		applyFilters() {
			this.filtersApplied = true;
			this.pagination.page = 1;
			this.appliedFilters = {
				...this.filters,
			};
			this.getConsoleData(this.tabIndex == 0 ? "individual" : "group");
		},
		hideFiltersDropdown() {
			this.filters = {
				...this.appliedFilters,
			};
			this.openFilter = false;
		},
		selectGroupView(index) {
			this.selectGroupIndex = index;
		},
		getDate(date) {
			return DateTime.fromISO(date).toFormat("dd-LL-yyyy");
		},
		resetFilter(type, apiCall = true) {
			this.filters = {
				sandboxTemplate: null,
				date: null,
				project: null,
				status: null,
			};
			this.pagination = {
				page: 1,
				count: 20,
			};
			this.appliedFilters = {};
			if (apiCall || this.filtersApplied) this.getConsoleData(type);
			this.filtersApplied = false;
		},
		async getConsoleData(type) {
			this.loading = true;
			try {
				const payload = {
					search: this.search || undefined,
					type: type,
					count: this.pagination.count,
					page: this.pagination.page - 1,
					filter: {
						templateID: this.appliedFilters.sandboxTemplate?.value,
						status: this.appliedFilters.status?.value,
						createdAt: this.appliedFilters.date || undefined,
						testID: this.appliedFilters.project?.value,
					},
				};
				if (this.sorting.column) {
					payload.sort = {
						...this.sorting,
					};
				}
				const response = await adminConsole(payload);
				this.consoleData = response.data.data.data;
				// this.consoleData.data = [];
			} catch (error) {
				this.consoleData = [];
				console.log(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped>
.admin-console-container .container {
	background-color: var(--color-white);
	width: 100%;
	height: 100%;
	max-width: unset;
}

.admin-console-container header {
	border-bottom: 1px solid #d7d7d7;
	height: 50px;
	padding-inline: 15px;
	background-color: transparent !important;
	border-radius: 0 !important;
	padding: 33px 24px 24px 24px;
}
.admin-console-container .container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
	width: 100%;
	padding-right: 0px;
	padding-left: 0px;
	margin-right: auto;
	margin-left: auto;
}

.custom-fields-body header h1 {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #000000;
}

.transparent-bar {
	width: 2px;
	height: 38px;
	border-radius: 2px;
	position: absolute;
	left: 2px;
	top: 3px;
	background-color: transparent;
}

.time-class {
	font-family: var(--Montserrat);
	font-style: italic;
	font-weight: var(--weight-R);
	font-size: var(--size-12);
	color: var(--navy-blue);
}

.group-font {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
}

.config-table-overflow {
	height: calc(100vh - 280px);
	overflow-y: auto;
	overflow-x: hidden;
	width: 100%;
}

.config-table-header {
	background: #72738e14;
	font-family: "Lato", sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #72738e;
	padding: 10px 15px;
	margin-inline: 2px;
}

.config-selected {
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	border-radius: 3px;
	position: relative;
	margin: 0px 2px 5px 2px;
	padding: 10px 0;
}

.blue-bar {
	width: 3px;
	border-radius: 2px;
	position: absolute;
	left: 2px;
	background-color: #72738e;
	height: calc(100% - 4px);
	top: 2px;
}

.adminConsole-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 220px);
	overflow-x: auto;
	overflow-y: hidden;
	padding: 18px 30px;
}

.adminConsole-table-header {
	min-width: 1300px;
	max-width: 100%;
	display: flex;
	align-items: center;
	background: #72738e14;
	font-family: "Lato", sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #72738e;
	padding: 10px 15px;
	margin-inline: 2px;
}

.adminConsole-table-body {
	min-width: 1308px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 330px);
}

.adminConsole-data-row {
	font-family: "Lato", sans-serif;
	font-size: 15px;
	font-weight: 400;
	color: #72738e;
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	padding: 10px 15px;
	margin-block: 10px;
	position: relative;
}

.height-40 {
	height: 40px;
}

.adminConsole-data-row:hover {
	background: #e7e8f5;
}

.adminConsole-sel-row {
	background-color: #e8e8eb;
}

.adminConsole-paginaTion {
	min-width: 1300px;
	max-width: 100%;
	padding: 7px 10px;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	border-radius: 5px;
	background: #fcfcfc;
}

.red-line {
	width: 86px;
	height: 5px;
	background: #ec0b05;
	border-radius: 2px;
}

.orange-line {
	width: 26px;
	height: 5px;
	background: #f28a2b;
	border-radius: 2px;
}

.green-line {
	width: 46px;
	height: 5px;
	background: #289604;
	border-radius: 2px;
}

.blue-line {
	width: 22px;
	height: 5px;
	background: #6c757d;
	border-radius: 2px;
}

.golden-line {
	width: 22px;
	height: 5px;
	background: #e4b320;
	border-radius: 2px;
}
.red-txt {
	color: #e70016;
}

.green-txt {
	color: #038e00;
}
.evaluated-txt {
	color: rgba(3, 92, 0, 1);
}
.paused-txt {
	color: rgba(0, 106, 202, 1);
}
.running-txt {
	color: rgba(242, 139, 43, 1);
}
.left-133 {
	left: 133px;
}

.height-250 {
	max-height: 250px;
}
.common-main-container {
	height: calc(100vh - 72px);
	top: 72px;
	padding-left: 80px;
	padding-right: 15px;
	width: auto;
}
</style>
